import { Button, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverHeader, PopoverTrigger, Text } from "@chakra-ui/react";
import React from "react";

export const CreateProject = () => {
  return (
    <Popover>
       <PopoverTrigger>
        <Text>Create</Text>
       </PopoverTrigger>
       <PopoverContent>
         <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader>Confirmation!</PopoverHeader>
        <PopoverBody>Are you sure you want to have that milkshake?</PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
